/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listing_Category_Digital_TravelInputs */

const en_listing_category_digital_travel = /** @type {(inputs: Listing_Category_Digital_TravelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Travel Guides`)
};

const es_listing_category_digital_travel = /** @type {(inputs: Listing_Category_Digital_TravelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guías de viaje`)
};

const fr_listing_category_digital_travel = /** @type {(inputs: Listing_Category_Digital_TravelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guides de voyage`)
};

const de_listing_category_digital_travel = /** @type {(inputs: Listing_Category_Digital_TravelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reiseführer`)
};

const ja_listing_category_digital_travel = /** @type {(inputs: Listing_Category_Digital_TravelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`旅行ガイド`)
};

const zh_listing_category_digital_travel = /** @type {(inputs: Listing_Category_Digital_TravelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`旅游指南`)
};

const ar_listing_category_digital_travel = /** @type {(inputs: Listing_Category_Digital_TravelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أدلة سفر`)
};

const id_listing_category_digital_travel = /** @type {(inputs: Listing_Category_Digital_TravelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Panduan Perjalanan`)
};

const it_listing_category_digital_travel = /** @type {(inputs: Listing_Category_Digital_TravelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guide di Viaggio`)
};

const ru_listing_category_digital_travel = /** @type {(inputs: Listing_Category_Digital_TravelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Путеводители`)
};

const pt_listing_category_digital_travel = /** @type {(inputs: Listing_Category_Digital_TravelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guias de Viagem`)
};

const ko_listing_category_digital_travel = /** @type {(inputs: Listing_Category_Digital_TravelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`여행 가이드`)
};

/**
* | output |
* | --- |
* | "Travel Guides" |
*
* @param {Listing_Category_Digital_TravelInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const listing_category_digital_travel = /** @type {((inputs?: Listing_Category_Digital_TravelInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listing_Category_Digital_TravelInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listing_category_digital_travel(inputs)
	if (locale === "es") return es_listing_category_digital_travel(inputs)
	if (locale === "fr") return fr_listing_category_digital_travel(inputs)
	if (locale === "de") return de_listing_category_digital_travel(inputs)
	if (locale === "ja") return ja_listing_category_digital_travel(inputs)
	if (locale === "zh") return zh_listing_category_digital_travel(inputs)
	if (locale === "ar") return ar_listing_category_digital_travel(inputs)
	if (locale === "id") return id_listing_category_digital_travel(inputs)
	if (locale === "it") return it_listing_category_digital_travel(inputs)
	if (locale === "ru") return ru_listing_category_digital_travel(inputs)
	if (locale === "pt") return pt_listing_category_digital_travel(inputs)
	return ko_listing_category_digital_travel(inputs)
});